import StatusCard from '../../components/common/ui/StatusCard';
import CustomCardWithHeader from '../../components/CustomCardWithHeader';
import RatingDistribution from '../../components/common/ui/RatingDistribution';
import ReviewsMessage from '../../components/common/ui/ReviewsMessage';
import {
  useFetchAllReviews,
  useFetchReviewOverall,
} from '../../../hook/useQueryData';
import { renderStars } from '../../../utils/renderStars';
import CustomPagination from '../../components/common/ui/CustomPagination';
import { useMemo, useState } from 'react';
import SmallLoadingSpinner from '../../components/common/ui/SmallLoadingSpinner';

const ProviderReview = ({ id }: any) => {
  const [currentPage, setCurrentPage] = useState<number>(1);

  const { data: apiReviews, isFetching: isFetchingReviews } =
    useFetchAllReviews(currentPage, 10, id);
  const { data: apiReviewOverall, isPending: isLodingReviewOverall } =
    useFetchReviewOverall(id);

  const overallRating = apiReviewOverall?.rating || [];
  const totalPage = useMemo(() => apiReviews?.pages || 1, [apiReviews]);

  return (
    <div className="mt-6">
      <div className="grid sm:grid-cols-6 gap-6  ">
        <StatusCard
          title={`Rating (${overallRating?.totalReviews || 0})`}
          value={
            overallRating?.averageRating !== undefined
              ? Number(overallRating.averageRating).toFixed(1)
              : 0
          }
          className=" sm:col-span-2 border-b-1"
          loading={isLodingReviewOverall}
          icon={
            <div className="flex gap-1">
              {renderStars(overallRating?.averageRating || 0)}
            </div>
          }
        />

        <CustomCardWithHeader
          title="Rating Distribution"
          isHeaderDevider={true}
          className="  sm:col-span-4 "
          mainContent={<RatingDistribution rating={overallRating} />}
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-1 gap-5 mt-6 items-start">
        {isFetchingReviews ? (
          <div className="col-span-full flex justify-center items-center">
            <SmallLoadingSpinner label="Loading..." />
          </div>
        ) : (
          <>
            {apiReviews?.review?.map((reviews: any, index: number) => (
              <ReviewsMessage data={reviews} key={index} />
            ))}
          </>
        )}
      </div>

      <div className="flex justify-end items-end">
        <CustomPagination
          className="pl-5 mt-10"
          showControls
          initialPage={1}
          size="sm"
          page={currentPage}
          total={totalPage}
          onChange={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default ProviderReview;
